namespace TabAurous.Retail {
    export namespace POSSalesWithoutTaxService {
        export const baseUrl = 'POSSalesWithoutTax/POSSalesWithoutTax';

        export declare function Create(request: Serenity.SaveRequest<POSSalesWithoutTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSSalesWithoutTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSSalesWithoutTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSSalesWithoutTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Authorize(request: AuthorizationRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "POSSalesWithoutTax/POSSalesWithoutTax/Create",
            Update = "POSSalesWithoutTax/POSSalesWithoutTax/Update",
            Delete = "POSSalesWithoutTax/POSSalesWithoutTax/Delete",
            Retrieve = "POSSalesWithoutTax/POSSalesWithoutTax/Retrieve",
            List = "POSSalesWithoutTax/POSSalesWithoutTax/List",
            Authorize = "POSSalesWithoutTax/POSSalesWithoutTax/Authorize"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'Authorize'
        ].forEach(x => {
            (<any>POSSalesWithoutTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
